<section class="wrapper">
  <div class="container">
    <div class="row">
      <div class="col">
        <ng-container *ngIf="curruntSettingsTabId != 4">
          <h2 class="title-h2">Settings</h2>
        </ng-container>
        <ng-container *ngIf="curruntSettingsTabId == 4">
          <h5 class="title-h2"><b>Notifications</b></h5>
        </ng-container>
      </div>
      <div class="col-12 col-sm-auto">
        <div class="settings-tab">
          <a (click)="settingsTab(1)" [class.active]="curruntSettingsTabId == 1"
            >Notificattions Settings</a
          >
          <a
            (click)="settingsTab(2)"
            [class.active]="curruntSettingsTabId == 2"
            (click)="getContactList(false)"
            >Emergency SOS</a
          >
          <ng-container *ngIf="role == 'Customer'">
            <a
              (click)="settingsTab(3)"
              [class.active]="curruntSettingsTabId == 3"
              (click)="getFavoritePlaces()"
              >Favorite Places</a
            >
          </ng-container>
          <a
            *ngIf="role == 'Customer'"
            (click)="settingsTab(5)"
            [class.active]="curruntSettingsTabId == 5"
          >
            Reciever's Notification
          </a>
          <a
            (click)="settingsTab(4)"
            [class.active]="curruntSettingsTabId == 4"
            (click)="getNotificationsList()"
          >
            <ng-container *ngIf="role == 'Customer'">
              Notification
            </ng-container>
            <ng-container *ngIf="role == 'Driver'"> Notification </ng-container>
          </a>
        </div>
      </div>
    </div>
    <div class="settings-tab-data">
      <div style="display: none" [class.d-block]="curruntSettingsTabId == 1">
        <div class="text-center my-3">
          <img
            class="img-responsive"
            src="assets/img/settings-notification.png"
          />
        </div>
        <h2 class="title-h2">Notify Me When</h2>
        <ng-container *ngIf="isLoadData">
          <div class="spinner-border spinner"></div>
        </ng-container>
        <ng-container *ngIf="!isLoadData">
          <ul class="setting-list" *ngIf="role == 'Customer'">
            <li>
              <label class="switch mb-0 pull-right">
                <input
                  type="checkbox"
                  (change)="updateSetting($event, 'wallet')"
                  [checked]="settingObject?.amountDeduction"
                />
                <span class="slider round"></span>
              </label>
              Amount deducted from my wallet
            </li>
            <li>
              <label class="switch mb-0 pull-right">
                <input
                  type="checkbox"
                  (change)="updateSetting($event, 'reached')"
                  [checked]="settingObject?.reachedDestination"
                />
                <span class="slider round"></span>
              </label>
              I reached on my destination
            </li>
            <li>
              <label class="switch mb-0 pull-right">
                <input
                  type="checkbox"
                  (change)="updateSetting($event, 'begin')"
                  [checked]="settingObject?.journeyBegin"
                />
                <span class="slider round"></span>
              </label>
              I begin my journey
            </li>
            <li>
              <label class="switch mb-0 pull-right">
                <input
                  type="checkbox"
                  (change)="updateSetting($event, 'picking')"
                  [checked]="settingObject?.driverReached"
                />
                <span class="slider round"></span>
              </label>
              Driver reached on picking point
            </li>
          </ul>

          <ul class="setting-list" *ngIf="role == 'Driver'">
            <li>
              <label class="switch mb-0 pull-right">
                <input
                  type="checkbox"
                  (change)="updateSetting($event, 'payment')"
                  [checked]="settingObject?.paymentReceived"
                />
                <span class="slider round"></span>
              </label>
              Payment Received
            </li>
            <li>
              <label class="switch mb-0 pull-right">
                <input
                  type="checkbox"
                  (change)="updateSetting($event, 'feedback')"
                  [checked]="settingObject?.feedbackReceived"
                />
                <span class="slider round"></span>
              </label>
              Feedback Received
            </li>
            <li>
              <label class="switch mb-0 pull-right">
                <input
                  type="checkbox"
                  (change)="updateSetting($event, 'cancel')"
                  [checked]="settingObject?.canceledRide"
                />
                <span class="slider round"></span>
              </label>
              Rider Cancel the Ride
            </li>
            <li>
              <label class="switch mb-0 pull-right">
                <input
                  type="checkbox"
                  (change)="updateSetting($event, 'withdraw')"
                  [checked]="settingObject?.paymentWithdraw"
                />
                <span class="slider round"></span>
              </label>
              Payment Withdraw
            </li>
          </ul>
        </ng-container>
      </div>

      <ng-container *ngIf="isLoadingContact">
        <div class="spinner-border spinner"></div>
      </ng-container>
      <ng-container *ngIf="!isLoadingContact">
        <div style="display: none" [class.d-block]="curruntSettingsTabId == 2">
          <div class="row mt-4" *ngIf="sosList.length > 0">
            <div class="col-lg-4 col-md-6 mb-4" *ngFor="let sos of sosList">
              <div class="ec-card">
                <div class="ec-img">
                  <img src="assets/img/ec-emr.png" />
                </div>
                <div class="ec-data">
                  <label>{{ sos.name }}</label>
                  {{ sos.phoneNo }}
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <h2 class="title-h2 font-weight-normal">Trusted Contacts</h2>
            </div>
            <div class="col-12 col-sm-auto">
              <a class="color-76 font-weight-bold" (click)="AddEditContact('')"
                >+ Add Contacts</a
              >
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <ul class="setting-list pt-3" *ngIf="!isContactNotFound">
                <li class="contact-li" *ngFor="let contact of contactList">
                  <div class="contact-li-img">
                    <span>{{ contact.key }}</span>
                  </div>
                  <div class="contact-li-data">
                    {{ contact?.name }}
                    <div>
                      <a href="tel:{{contact?.phoneNo} "
                        ><img
                          class="mr-2"
                          src="assets/img/con-phone-call.png"
                        />
                        {{ contact?.phoneNo | customPhone : "US" }}</a
                      >
                      <a href="mailto:{{ contact?.email }}"
                        ><img class="mr-2" src="assets/img/con-email.png" />{{
                          contact?.email
                        }}</a
                      >
                    </div>
                  </div>
                  <div
                    class="contact-li-action"
                    (click)="AddEditContact(contact)"
                  >
                    <a><i class="fa fa-pencil"></i></a>
                  </div>
                  &nbsp;&nbsp;
                  <div
                    class="contact-li-action"
                    (click)="getDetail(contact)"
                    data-toggle="modal"
                    data-target="#exampleModal"
                  >
                    <a (click)="deleteContact()" href="javascript:void(0);"
                      ><i class="fa fa-times"></i
                    ></a>
                  </div>
                </li>
              </ul>
              <div *ngIf="isContactNotFound">
                <div class="card mt-4">
                  <div class="card-body text-center">Not Found</div>
                </div>
              </div>
              <br /><br />
            </div>
          </div>
        </div>
      </ng-container>
      <div style="display: none" [class.d-block]="curruntSettingsTabId == 3">
        <ul class="setting-list pt-3">
          <!-- *ngIf="!isPlacesNotFound" -->
          <li>
            <form class="form-w" [formGroup]="addFavPlaceForm">
              <div class="row">
                <!-- <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Title</label>
                                        <input type="text" class="form-control" placeholder="Title" formControlName="type" 
                                        [ngClass]="{ 'is-invalid': (submitted || f.type.touched && !f.type.valid) && f.type.errors }">
                                        <div *ngIf="((submitted || f.type.touched) && f.type.errors)" class="invalid-feedback">
                                        <div *ngIf="f.type.errors.required">Title is required</div>
                                        </div>
                                    </div>
                                </div> -->
                <div class="col-sm-4">
                  <div class="form-group">
                    <label>Title</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Title"
                      formControlName="type"
                      [ngClass]="{
                        'is-invalid':
                          (submitted || f.type.touched) && f.type.errors
                      }"
                    />

                    <!-- Validation Messages for 'type' (One at a time) -->
                    <div
                      *ngIf="(submitted || f.type.touched) && f.type.errors"
                      class="invalid-feedback"
                    >
                      <!-- Check 'required' first -->
                      <div *ngIf="f.type.errors.required">
                        Title is required.
                      </div>
                      <!-- Check 'whitespace' only if 'required' isn't the error -->
                      <div
                        *ngIf="
                          !f.type.errors.required && f.type.errors.whitespace
                        "
                      >
                        Title cannot be just whitespace.
                      </div>
                    </div>
                  </div>
                </div>

             
                <div class="col">
                  <div class="form-group">
                    <label>Address</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Address"
                      formControlName="name"
                      ngx-google-places-autocomplete
                      [options]="options"
                      (onAddressChange)="handleAddressChange($event)"
                      [ngClass]="{
                        'is-invalid':
                          (submitted || f.name.touched) && f.name.errors
                      }"
                    />

                    <!-- Validation Messages for 'name' (One at a time) -->
                    <div
                      *ngIf="(submitted || f.name.touched) && f.name.errors"
                      class="invalid-feedback"
                    >
                      <!-- Check 'required' first -->
                      <div *ngIf="f.name.errors.required">
                        Address is required.
                      </div>
                      <!-- Check 'whitespace' only if 'required' isn't the error -->
                      <div
                        *ngIf="
                          !f.name.errors.required && f.name.errors.whitespace
                        "
                      >
                        Address cannot be just whitespace.
                      </div>
                    </div>
                    {{ formattedaddress }}
                  </div>
                </div>
                <div class="col-auto pt-1">
                  <button
                    class="btn btn-primary mt-4"
                    (click)="addFavPlace()"
                    [disabled]="isLoadingFavPlaceData"
                  >
                    <span *ngIf="isLoadingFavPlaceData">
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </span>
                    Add Address
                  </button>
                </div>
              </div>
            </form>
          </li>
          <ng-container *ngIf="favPlaceList">
            <li *ngFor="let fp of favPlaceList">
              <div class="pull-right settings-options">
                <span class="settings-options-dots">
                  <i class="fa fa-circle"></i>
                  <i class="fa fa-circle"></i>
                  <i class="fa fa-circle"></i>
                </span>
                <span class="settings-options-item">
                  <a
                    (click)="open(content, fp._id, fp.type, fp.name)"
                    href="javascript:void(0);"
                    ><i class="fa fa-pencil"></i
                  ></a>
                  <a (click)="deleteFavPlace(fp._id)" href="javascript:void(0);"
                    ><i class="fa fa-times"></i
                  ></a>
                </span>
              </div>
              <div class="row">
                <div class="col-3">
                  <b>{{ fp.type | titlecase }}</b>
                </div>
                <div class="col">{{ fp.name }}</div>
              </div>
            </li>
          </ng-container>
        </ul>
        <div *ngIf="!favPlaceList">
          <div class="card">
            <div class="card-body text-center">Not Found</div>
          </div>
        </div>
      </div>
      <div style="display: none" [class.d-block]="curruntSettingsTabId == 4">
        <!-- If role is Driver-->
        <ng-container *ngIf="role == 'Driver'">
          <span *ngIf="isLoading && !isLoadingContact">
            <span
              class="spinner-border spinner"
              role="status"
              aria-hidden="true"
            ></span>
          </span>
          <ng-container *ngIf="!isLoading">
            <ul class="setting-list pt-3">
              <li *ngIf="!notificationsList.length">
                <div class="card mt-4">
                  <div class="card-body">
                    <p class="color-76 m-0 text-center">No Notifications</p>
                  </div>
                </div>
              </li>
              <li
                *ngFor="let notification of notificationsList"
                [class.notification-unread]="notification.status == 'unread'"
              >
                <div class="pull-right settings-options">
                  <div class="contact-li-action">
                    <a
                      href="javascript:void(0);"
                      (click)="deleteNoti(notification)"
                      data-toggle="modal"
                      data-target="#exampleModal"
                      ><i class="fa fa-times"></i
                    ></a>
                  </div>
                </div>
                <div class="row">
                  <div class="col-auto">
                    <img
                      class="img-responsive"
                      src="assets/img/notifications-button.png"
                    />
                  </div>
                  <div class="col">
                    {{ notification.text }}<br />
                    <div>
                      <small>{{
                        notification.updatedAt | date : "MMM d, y, h:mm a"
                      }}</small>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="row">
              <div class="col">
                <a
                  href="javascript:void(0)"
                  class="text-theme"
                  (click)="prevNotifications()"
                  *ngIf="isNotiPrev"
                  ><i class="fa fa-long-arrow-left"></i> Previous</a
                >
              </div>
              <div class="col-auto">
                <a
                  href="javascript:void(0)"
                  class="text-theme"
                  (click)="nextNotifications()"
                  *ngIf="isNotiNext"
                  >Next <i class="fa fa-long-arrow-right"></i
                ></a>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- If role is Driver-->
        <ng-container *ngIf="role == 'Customer'">
          <span *ngIf="isLoading && !isLoadingContact">
            <span
              class="spinner-border spinner"
              role="status"
              aria-hidden="true"
            ></span>
          </span>
          <ng-container *ngIf="!isLoading">
        
            <ul class="setting-list pt-3">
              <li *ngIf="!notificationsList.length">
                <div class="card mt-4">
                  <div class="card-body">
                    <p class="color-76 m-0 text-center">No Notifications</p>
                  </div>
                </div>
              </li>
              <li
                *ngFor="let notification of notificationsList"
                [class.notification-unread]="notification.status == 'unread'"
              >
                <div class="pull-right settings-options">
                  <div class="contact-li-action">
                    <a
                      href="javascript:void(0);"
                      (click)="deleteNoti(notification)"
                      data-toggle="modal"
                      data-target="#exampleModal"
                      ><i class="fa fa-times"></i
                    ></a>
                  </div>
                </div>
                <div class="row">
                  <div class="col-auto">
                    <img
                      class="img-responsive"
                      src="assets/img/notifications-button.png"
                    />
                  </div>
                  <div class="col">
                    {{ notification.text }}<br />
                    <div>
                      <small>{{
                        notification.updatedAt | date : "MMM d, y, h:mm a"
                      }}</small>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="row">
              <div class="col">
                <a
                  href="javascript:void(0)"
                  class="text-theme"
                  (click)="prevNotifications()"
                  *ngIf="isNotiPrev"
                  ><i class="fa fa-long-arrow-left"></i> Previous</a
                >
              </div>
              <div class="col-auto">
                <a
                  href="javascript:void(0)"
                  class="text-theme"
                  (click)="nextNotifications()"
                  *ngIf="isNotiNext"
                  >Next <i class="fa fa-long-arrow-right"></i
                ></a>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <div
        *ngIf="role == 'Customer'"
        style="display: none"
        [class.d-block]="curruntSettingsTabId == 5"
      >
  
        <ng-container *ngIf="!isLoading">
          <div class="card mt-4">
            <div class="card-body">
              <p class="color-76">
                Quickly drive optimal supply chains through just in time
                materials. Synergistically initiate state of the art networks
                through viral expertise. Authoritatively build performance based
                meta-services whereas holistic information.
              </p>
              <button class="btn btn-primary">Edit Message</button>
            </div>
          </div>
          <div class="card mt-4">
            <div class="card-body">
              <div class="text-center">
                <p class="color-76">No Message Found</p>
                <button class="btn btn-primary">Add Message</button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>

<!--Delete Confirmation Modal-->
<div
  class="modal fade"
  id="exampleModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          Are you sure you want to delete ?
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Close
        </button>
        <ng-container *ngIf="curruntSettingsTabId == 2">
          <button
            type="button"
            class="btn btn-primary"
            (click)="deleteContact()"
            data-dismiss="modal"
          >
            Yes
          </button>
        </ng-container>
        <ng-container *ngIf="curruntSettingsTabId == 4">
          <button
            type="button"
            class="btn btn-primary"
            (click)="deleteNotification()"
            data-dismiss="modal"
          >
            Yes
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- <ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Favorite Address update</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form class="form-w" [formGroup]="editFavPlaceForm">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Title</label>
            <input
              type="text"
              class="form-control"
              placeholder="Title"
              formControlName="type"
              [ngClass]="{
                'is-invalid':
                  (submittedEdit || (fe.type.touched && !fe.type.valid)) &&
                  fe.type.errors
              }"
            />
            <div
              *ngIf="(submittedEdit || fe.type.touched) && fe.type.errors"
              class="invalid-feedback"
            >
              <div *ngIf="fe.type.errors.required">Title is required</div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Address</label>
            <input
              type="text"
              class="form-control"
              placeholder="Address"
              formControlName="name"
              ngx-google-places-autocomplete
              [options]="options"
              (onAddressChange)="handleAddressChangeEdit($event)"
              [ngClass]="{
                'is-invalid':
                  (submittedEdit || (fe.name.touched && !fe.name.valid)) &&
                  fe.name.errors
              }"
            />

            <div
              *ngIf="(submittedEdit || fe.name.touched) && fe.name.errors"
              class="invalid-feedback"
            >
              <div *ngIf="fe.name.errors.required">Address is required</div>
            </div>
            {{ formattedaddressEdit }}
          </div>
        </div>
      </div>
      <div class="text-center">
        <button
          class="btn btn-primary mt-sm-4"
          (click)="editFavPlaceSubmit()"
          [disabled]="isLoadingFavPlaceDataEdit"
        >
          <span *ngIf="isLoadingFavPlaceDataEdit">
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </span>
          Update Address
        </button>
      </div>
    </form>
  </div>
</ng-template> -->

<!-- Chetu Code Start Here-->

<ng-template #content let-modal>
  <div class="modal-header">
    <!-- ... (modal header content remains the same) ... -->
    <h4 class="modal-title" id="modal-basic-title">Favorite Address update</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form class="form-w" [formGroup]="editFavPlaceForm">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Title</label>
            <input
              type="text"
              class="form-control"
              placeholder="Title"
              formControlName="type"
              [ngClass]="{
                'is-invalid':
                  (submittedEdit || fe.type.touched) && fe.type.errors
              }"
            />
            <!-- Validation Messages for 'type' (One at a time) -->
            <div
              *ngIf="(submittedEdit || fe.type.touched) && fe.type.errors"
              class="invalid-feedback"
            >
              <!-- Show required first -->
              <div *ngIf="fe.type.errors.required">Title is required.</div>
              <!-- Show whitespace only if not required -->
              <div
                *ngIf="!fe.type.errors.required && fe.type.errors.whitespace"
              >
                Title cannot be just whitespace.
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Address</label>
            <input
              type="text"
              class="form-control"
              placeholder="Address"
              formControlName="name"
              ngx-google-places-autocomplete
              [options]="options"
              (onAddressChange)="handleAddressChangeEdit($event)"
              [ngClass]="{
                'is-invalid':
                  (submittedEdit || fe.name.touched) && fe.name.errors
              }"
            />

            <!-- Validation Messages for 'name' (One at a time) -->
            <div
              *ngIf="(submittedEdit || fe.name.touched) && fe.name.errors"
              class="invalid-feedback"
            >
              <!-- Show required first -->
              <div *ngIf="fe.name.errors.required">Address is required.</div>
              <!-- Show whitespace only if not required -->
              <div
                *ngIf="!fe.name.errors.required && fe.name.errors.whitespace"
              >
                Address cannot be just whitespace.
              </div>
            </div>
            {{ formattedaddressEdit }}
          </div>
        </div>
      </div>
      <div class="text-center">
        <button
          class="btn btn-primary mt-sm-4"
          (click)="editFavPlaceSubmit()"
          [disabled]="isLoadingFavPlaceDataEdit"
        >
          <span *ngIf="isLoadingFavPlaceDataEdit">
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </span>
          Update Address
        </button>
      </div>
    </form>
  </div>
</ng-template>

<!-- Chetu Code End Here-->
